export class ConfirmarRecebimentoModel {
    constructor (
        public imagemDados: string = '',
        public ids: string[] = [],
    ) {}
}